<trustholder-manager (trustHolderSaved)="notify($event)" (trustHolderDeleted)="notify($event)"></trustholder-manager>
